import { setupCultureCircleBrandSpecificScripts } from "./cc";

export const BrandSpecificProvider = {
  init() {
    try {
      setupCultureCircleBrandSpecificScripts();
    } catch (e) {
      console.log(e);
    }
  },
};
